export const images = [
  {
    imgUrl:
      "https://images.unsplash.com/photo-1593955738009-23f17811520b?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1525&q=80",
    alt: "first slide image",
    header: "Glasses for life",
    sub: "Summer 2021 Collection",
  },
  {
    imgUrl: "https://i.imgur.com/6LDMFAA.png",
    alt: "second slide image",
    header: "Just added!",
    sub: "Shop new arrivals now",
  },
];
